/* eslint-disable @typescript-eslint/no-namespace */

export namespace Viewing {
  export namespace Extensions {
    export const TEXTOVERLAY_INITIALIZED_EVENT: string = "textOverlayInitialized";
    export const TEXTOVERLAY_UNINITALIZED_EVENT: string = "textOverlayUnitialized";
    export const TEXTOVERLAY_UPDATE_LEGEND_EVENT: string = "textOverlayUpdateLegend";
  }
}
